const MAX_BREADCRUMBS = 20;

class BreadcrumbCollector {
	constructor() {
		this.breadcrumbs = [];
		this._initialized = false;
	}

	init() {
		if (this._initialized) return;
		this._initialized = true;

		// Track click events (delegated)
		document.addEventListener("click", (e) => {
			const target = e.target;
			const selector = this._getElementSelector(target);
			const text = (target.textContent || "").substring(0, 50).trim();
			this.add("click", "ui.click", `Clicked: ${selector}`, {
				selector,
				text,
				tagName: target.tagName,
				id: target.id || undefined,
			});
		}, { passive: true, capture: true });

		// Track navigation (popstate)
		window.addEventListener("popstate", () => {
			this.add("navigation", "navigation", `Navigated to ${window.location.pathname}`, {
				url: window.location.pathname,
			});
		});
	}

	add(type, category, message, data = {}) {
		this.breadcrumbs.push({
			type,
			category,
			message,
			data,
			timestamp: new Date().toISOString(),
		});
		if (this.breadcrumbs.length > MAX_BREADCRUMBS) {
			this.breadcrumbs.shift();
		}
	}

	addNavigation(pageName, url) {
		this.add("navigation", "navigation", `Navigated to ${pageName}`, {
			url: url || window.location.pathname,
			pageName,
		});
	}

	addApiCall(method, url, status, duration) {
		const type = status ? "api_response" : "api_request";
		this.add(type, "http", `${method} ${url ? url.substring(0, 100) : "?"} -> ${status || "pending"}`, {
			method,
			url: url ? url.substring(0, 200) : undefined,
			status,
			duration,
		});
	}

	addCustom(message, data = {}) {
		this.add("custom", "custom", message, data);
	}

	getBreadcrumbs() {
		return [...this.breadcrumbs];
	}

	_getElementSelector(el) {
		if (!el || !el.tagName) return "unknown";
		let selector = el.tagName.toLowerCase();
		if (el.id) selector += `#${el.id}`;
		else if (el.className && typeof el.className === "string") {
			const cls = el.className.split(" ").filter(Boolean).slice(0, 2).join(".");
			if (cls) selector += `.${cls}`;
		}
		return selector;
	}
}

const breadcrumbCollector = new BreadcrumbCollector();
export default breadcrumbCollector;
